import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-iframe",
  template: `
    <iframe
      *ngIf="load"
      [style.display]="visible ? null : 'none'"
      [src]="source"
      [width]="iframeWidth"
      [height]="iframeHeight"
      [ngClass]="classes"
      frameborder="0"
      allowfullscreen
      allow="microphone">
    </iframe>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IframeComponent implements OnChanges {
  @Input() iframeSrc: string;
  @Input() iframeWidth = "100%";
  @Input() iframeHeight = "100%";
  @Input() visible = false;
  @Input() load = true;
  @Input() classes = "";

  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly changeDetector: ChangeDetectorRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.visible) {
      this.changeDetector.markForCheck();
    }
  }

  get source(): SafeResourceUrl {
    const source = this.load ? this.iframeSrc : "";
    return this.domSanitizer.bypassSecurityTrustResourceUrl(source);
  }
}
